import {
  IMAGE_UPLOAD,
  GIF_UPLOAD,
  VIDEO_UPLOAD,
  PDF_UPLOAD,
  YOUTUBE_URL,
} from "../../Constants/types";

export const mediaOptions = [
  {
    type: IMAGE_UPLOAD,
    title: "Upload an image",
    alt: "image",
    accept: "image/*",
  },
  {
    type: GIF_UPLOAD,
    title: "Upload a gif",
    alt: "gif",
    accept: "image/gif",
  },
  {
    type: PDF_UPLOAD,
    title: "Upload a pdf",
    alt: "pdf",
    accept: "application/pdf",
  },
  {
    type: VIDEO_UPLOAD,
    title: "Upload your own video file",
    alt: "video",
    accept: "video/*",
  },
  {
    type: YOUTUBE_URL,
    title: "Youtube video embed",
    alt: "youtube video",
    accept: "text/plain",
  },
];



// WEBPACK FOOTER //
// ./src/components/UploadPanel/constants.js